import { render, staticRenderFns } from "./editOrderModel1.vue?vue&type=template&id=82953e24&scoped=true&"
import script from "./editOrderModel1.vue?vue&type=script&lang=js&"
export * from "./editOrderModel1.vue?vue&type=script&lang=js&"
import style0 from "./editOrderModel1.vue?vue&type=style&index=0&id=82953e24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82953e24",
  null
  
)

export default component.exports